import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {API_CALL_STATUS} from '../../metadata/enums'
import Config from "../../config";
import axios from "axios";
import {LOGGER} from "../../utils/Logger";

const initialState = {
  user: null, //this is only the firebase user with uid and email
  status: API_CALL_STATUS.IDLE,
  error: null
}





const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    addUser(state, action) {
      return Object.assign({}, state, {user: action.payload})
    },
  },

})



// export const asyncUserAction = amount => dispatch => {
// 	console.log('thunk called', amount)
// 	setTimeout(() => {
// 		console.log('dispatched after timeout')
// 		dispatch(userSlice.actions.testAdded(amount))
// 	}, 1000)
// }

export const {addUser, updateUserUpdatedStatus, updateNewUserStatus, addMongoUser} = userSlice.actions

export default userSlice.reducer
